<style>
.betscollom {
  display: block;
}

@media (max-width: 767px) {
  .betscollom {
    display: none !important;
    
  }
.mblockonmobile{
    display: none !important;
    
  }
  /* 2. Make .box.mt-1 width 100% on mobile */
  .box.mt-1 {
    width: 100% !important;
  }
   .mbtn{
        width: 50%;
    }
    
   
}
 .span{
     font-weight: 700 !important;
    }
    span {
  font-weight: 700 !important;
}

</style>
<div style="    width: 100% !important; display: flex;">
    <style>
.bet-table-header{
    border-bottom: 0px solid #c7c8ca;
    border-top: 0px solid #c7c8ca;
    padding: 0px 0;}
    
    .odd-box{
        border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    float: left;
    font-size: 14px;
    line-height: 13px !important;
    padding: 5px 0;
    width: 49% !important;
        margin-right: 0.5%;
    }
    .bet-table-row
    {padding: 2px 1px;}
    
   
    .bet-nation-game-name span {
        color: #000 !important;
    font-family: Roboto Condensed, sans-serif !important;
    font-weight: 700 !important;
            cursor: pointer;
    display: inline-block;
    font-weight: 700;
    line-height: 17px;
    max-width: 750px !important;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
}
    }
    
    .over-wrap {
    overflow: hidden;
    overflow-y: auto;
}
/* Hide on mobile (less than 768px) */
.goneonmobile {
  display: none;
}

/* Show on desktop (768px and up) */
@media (min-width: 768px) {
  .goneonmobile {
    display: block;
      

  }
  .mbmb1oa{
      width:84%;
  }
}

</style>

    
                    <div class="col-left col-left-login goneonmobile" style="width: 16%; background-color: #FFF;" id="sidebar"><div class="sub_path over-wrap">
                <ul class="list-unstyled components">
  <p style=" background-color: #072c50;
    color: #fff;     margin: 0;
    padding: 2px 7px;
    text-transform: capitalize;">Popular <i class="fa fa-close pt-1 icon-toggle-right mobile-menu float-right"></i></p>
<style>
element.style {
    text-transform: capitalize;
}
#sidebar ul li a {
    border-bottom: 1px solid #e8e8e8;
    color: #000;
}
#sidebar ul li a {
    align-items: center;
    display: flex
;
    padding: 8px 10px;
}
#sidebar ul li a, #sidebar ul p {
    font-family: Roboto Condensed, sans-serif;
    font-size: 14px;
    font-weight: 700;
}
a[data-toggle=collapse] {
    position: relative;
}
a:not([href]), a:not([href]):hover {
    color: inherit;
    text-decoration: none;
}
.dropdown-toggle {
    white-space: nowrap;
}
a, a:active, a:focus, a:hover {
    outline: none;
    text-decoration: none;
}
a {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
a {
    background-color: transparent;
    color: #007bff;
}
#sidebar ul li a:hover {
    background-color: #f8bd23;
    color: #000;
}
.list-unstyled.components .sports-icon {
    background-position: 0 -900px;
    background-repeat: no-repeat;
    background-size: 28px auto;
    display: inline-block;
    height: 24px;
    margin-right: 5px;
    overflow: hidden;
    vertical-align: bottom;
    width: 28px;
    background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png);
}
#sidebar ul li dropdown-toggle:hover {
    background-color: #f8bd23;
}

.dropdown-toggle::after {
        display: block;
    font-size: 16px;
    position: absolute;
   
        left: 14%;

    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    
    #sidetree {
    background: #e1e4ef;
    font-size: 12px;
    padding: 2px 5px;
}
}
</style>
 

  <li>
    <a aria-expanded="true"><span class="sports-icon inplayside" style=" background-position: 0 -1527px;"></span> In-Play</a>
  </li>

  <li>
    <a href="/ipl"><span class="sports-icon iplwinnerside" style="background-position: 0 -1775px;"></span> IPL 2025</a>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon cricketside" style="background-position: 0 -326px;"></span> Cricket</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Indian Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Royal Challengers Bengaluru v Rajasthan Royals</span></li>
            <li class="treeview"><span class="treeviewnode">Kolkata Knight Riders v Punjab Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Chennai Super Kings v Sunrisers Hyderabad</span></li>
            <li class="treeview"><span class="treeviewnode">Mumbai Indians v Lucknow Super Giants</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Womens One Day Internationals</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Sri Lanka Women v India Women</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">International Twenty20 Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Canada v USA</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Pakistan Super League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Quetta Gladiators v Karachi Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Lahore Qalandars v Peshawar Zalmi</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Test Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Bangladesh v Zimbabwe</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon soccerside" style="background-position: 0 -1026px;"></span> Soccer</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Spanish La Liga</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Getafe v Real Madrid</span></li>
            <li class="treeview"><span class="treeviewnode">Alaves v Real Sociedad</span></li>
            <li class="treeview"><span class="treeviewnode">Leganes v Girona</span></li>
            <li class="treeview"><span class="treeviewnode">Osasuna v Sevilla</span></li>
            <li class="treeview"><span class="treeviewnode">Atletico Madrid v Rayo Vallecano</span></li>
            <li class="treeview"><span class="treeviewnode">Betis v Valladolid</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Dutch Eredivisie</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Az Alkmaar v NAC Breda</span></li>
            <li class="treeview"><span class="treeviewnode">FC Twente v PSV</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">English Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Arsenal v Crystal Palace</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>
 
<li>
    <a href="/ipl"><span class="sports-icon iplwinnerside" style="background-position: 0 -1742px;"></span>Indian Poker II</a>
</li>
<li>
    <a href="/ipl"><span class="" style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px; background-position: 0 -1775px;"><img style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px;" class="ball-images-tab" src="https://images.staticcontent.io/casino/banner/images/aviator-icon.svg" alt=""></span> Aviator</a>
</li>

<li 
    >
  
   <a href="./dashboard/livecasino?vendorId=AWC"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      AE Sexy
    </a>
</li>
<li *ngFor="let vendor of vendors"
    >
  
   <a href="./dashboard/livecasino?vendorId={{ vendor.providerCode }}"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      {{ vendor.providerName }}
    </a>

   

  <!--<ul class="dropdown-menu" style="background-color: #edf0fa; border-radius: 5px; padding: 10px; min-width: 240px;">-->
  <!--  <li *ngFor="let category of categories" style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #ddd;">-->
      
  <!--    <a class="dropdown-item" href="javascript:void(0);" -->
  <!--       (click)="onSelectCategory(category); onVendorChange(vendor.providerCode)"-->
  <!--       style="text-decoration: none; color: #000; padding-left: 10px; border-left: 2px solid #007bff; flex-grow: 1;">-->
  <!--      {{ category }}-->
  <!--    </a>-->

  <!--    <span style="display: inline-block; background-color: #fff; border: 1px solid #ccc; padding: 0px 5px; font-weight: bold; font-size: 14px; margin-left: 10px;">+</span>-->
  <!--  </li>-->
  <!--</ul>-->
</li>



</ul>
</div>
</div>

    <div class="box mt-1" style="width: 70%;" >
  <div class="ballbyshow" style="display:none;">
    <h4 class="text-light d-flex align-items-center mb-0">
      <!-- <div class="material-symbols-outlined"> info </div> -->
      <!-- <i class="fas fa-info-circle"></i>
      <div class="ballby ml-1">Ball By Ball</div> -->
    </h4>
  </div>
<style>
.body{
    background: #ececed;
    color: #a1aed4;
    font-size: 14px;
    margin: 0;
    overflow-anchor: none;
    font-family: Roboto Condensed, sans-serif;
    overflow-x: hidden;
    scroll-behavior: smooth;
}
.odd-btn{
    height: 44px;
    border-radius: 4px;
}
.mbtn{
      height: 44px;
    border-radius: 4px;
}
</style>
  <!-- ball by ball score card -->
  <div
    *ngIf="is_score"
    class="scorecard-banner"
    style="
      background: url('/assets/images/bg-banner.png');
      background-position: center;
    "
  >
    <div class="scorecard">
      <div class="scorecard-row">
        <div class="row row5">
          <div class="col-6 text-lg-left active-team">
            <div>
              <b>{{ score.teams[0].team_name }}</b>
              {{ score.teams[0].score }}
            </div>
            <div>
              <span class="span">
                CRR
                {{ score.currentRunRate }} </span
              ><span class="span">
                RR
                {{ score.requireRunRate }}
              </span>
            </div>
          </div>
          <div class="col-6 text-lg-right">
            <div>
              <b>{{ score.teams[1].team_name }}</b>
              {{ score.teams[1].score }}
            </div>
            <div>
              <!---->
              <!---->
            </div>
          </div>
        </div>
      </div>
      <div class="scorecard-row">
        <div class="row row5">
          <div class="col-lg-8 col-6 text-left">
            {{ score.msg }}
          </div>
          <div
            *ngIf="score.hasOwnProperty('last24ballsNew')"
            class="col-lg-4 col-6 text-lg-right text-right"
          >
            <span
              [class.wicket]="ball.score_card == 'ww'"
              [class.four]="ball.score_card == '4'"
              [class.six]="ball.score_card == '6'"
              *ngFor="
                let ball of getInterestingReverseLoop(
                  last24ballsNew,
                  score.current_over
                )
              "
              class="ball-runs mr-1"
            >
              {{ ball.score_card }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ball by ball score card -->
  <!-- score card ifram -->

  <iframe
    *ngIf="inplay"
    style="width: 100%;"
    frameborder="0"
    allowfullscreen
    [src]="scoreurl"
  ></iframe>

  <!-- score card ifram -->
  <!-- <div class="video-card border-light"> -->
  <!-- <iframe class="video-card" src="https://nlivetv.lagaikhaipro.com/rtv.php?eventId=32516721"></iframe> -->
  <!--    <iframe width="100%" height="100%"></iframe>-->

  <div class="iframe-container" *ngIf="show_tv && inplay">
    <iframe frameborder="0" allowfullscreen [src]="videourl"></iframe>
  </div>
  <!-- </div> -->

  <div class="bg-title d-flex justify-content-between mb-0">
    <div
      class="title d-flex justify-content-between align-items-center p-2 match-name"
      *ngIf="markets.length > 0"
    >
      <!-- <img src="assets/images/blue_cric.png" /> -->
      <div class="ml-0">
        <div class="h5 mb-0 text-left" style="font-size: 10px">
          {{ competition_name + " > " + market_name }}
        </div>
        <div style="font-size: 10px">
          {{ marketStartTime | date : "dd/MM/YYYY H:mm " : "IST" }}
          (UTC+05:30)
        </div>
      </div>
      <div (click)="toggleShowTv()">
        <i class="fas fa-tv"></i>
      </div>
    </div>
  </div>

  <mat-tab-group
    [(selectedIndex)]="selectedTabIndex"
    dynamicHeight
    class="mt-0 p-0 m-0"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
  >
    <mat-tab label="">
      <div
        *ngIf="
          markets.length < 1 &&
          book_maker_odd.length < 1 &&
          fancies.length < 1 &&
          sessions.length < 1
        "
        class="nodata"
      >
        <span class="span">No Data Found...</span>
        
      </div>
      <div class="card rounded" *ngIf="markets.length > 0">
        <div class="text-white">
          <div style="" class="title text-light">
            <!-- <div class="newhead">{{ market_name }}</div > -->
            <style>
                .newhead{
                        background-color: #072c50;

                }
            </style>
            <span class=" span newhead">
              <span style="margin-left: -10px">
                <img
                  src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                  class="mr-1"
                />
                <span style="position: absolute; margin-left: 7px; "
                  >MATCH_ODDS</span
                >
              </span>
              <span
                class="text-light float-right"
                style="font-size: 12px; font-weight: 600px"
                >Max: 1L</span
              >
            </span>
            <div *ngIf="1 < 0" class="ml-3">
              <div style="text-align: right" class="title">
                <!-- <span class=" span text-warning">Max Bets: 200000</span><br> -->
                <button
                  (click)="display_cashout()"
                  class="button"
                  type="button"
                  style="
                    background: yellow;
                    text-transform: uppercase;
                    font-size: 10px;
                    font-weight: 700;
                    font-style: italic;
                    border: 1px solid #000000;
                    border-radius: 2px;
                  "
                >
                  CASHOUT
                </button>
                <!-- <button (click)="display_cashout()" *ngIf="status=='loss'" class="button" type="button"
                    style="background: yellow;
                    text-transform: uppercase;
                    font-size: 10px;
                    font-weight: 700;
                    font-style: italic;
                    border: 1px solid #000000;
                    border-radius: 2px;"
                >
                  CASHOUT
                </button> -->
              </div>

              <div
                [class.d-none]="show_cashout_confirm == false"
                [class.d-block]="show_cashout_confirm == true"
                style="text-align: right"
                class="title"
              >
                <div
                  style="
                    font-size: 15px;
                    color: #000;
                    padding: 5px;
                    margin-top: 5px;
                  "
                  id="div_conf"
                >
                  Are you sure you want to cashout
                  {{ total_profit_loss | currency : "₹" }} ?<br /><br />
                  <button
                    type="button"
                    (click)="submit_cashout(true)"
                    style="
                      margin-right: 2px;
                      float: none;
                      height: 40px;
                      color: #fff;
                      background: rgb(39, 125, 38);
                      font-size: 13px;
                      border: solid 1px #fff;
                      padding: 8px;
                      border-radius: 15px;
                      width: 32%;
                    "
                  >
                    Yes
                  </button>

                  <button
                    type="button"
                    (click)="submit_cashout(false)"
                    style="
                      margin-right: 2px;
                      float: none;
                      height: 40px;
                      color: #fff;
                      background: red;
                      font-size: 13px;
                      border: solid 1px #fff;
                      padding: 8px;
                      border-radius: 15px;
                      width: 32%;
                    "
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body p-1">
          <div class="d-flex justify-content-between d-none-mobile bl-btn">
            <div class="title text-right">&nbsp;</div>
            <button class="btn mbtn p-0 font-weight-bold odd-btn">
              &nbsp;
            </button>
            <button class="btn mbtn p-0 font-weight-bold odd-btn">
              &nbsp;
            </button>
            <button
              class="btn mbtn p-0 font-weight-bold odd-btn text-light max-details"
            >
              Max: 2L
            </button>
            <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn">
              Back
            </button>

            <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn">
              Lay
            </button>
            <button class="btn mbtn p-0 ml-1 font-weight-bold odd-btn">
              &nbsp;
            </button>
          </div>
          <div class="d-flex justify-content-between p-1 border-secondary">
            <div class="title" style="font-weight:700 !important;">
              <span class=" span font-12 font-weight-bold" style="font-weight:700 !important;">{{ market[0].runner1 }}</span
              ><br />
              {{ market.exp_amount1 }}
              <span
                *ngIf="market[0].exp_amount1 != 0"
                class="font-weight-bold"
                [class.text-danger]="market[0].exp_amount1 < 0"
                [class.text-success]="market[0].exp_amount1 >= 0"
                >{{ market[0].exp_amount1 }}
              </span>
            </div>
            <!-- back3 runner1 start -->
            <button
              #btn
              mat-button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].back02_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back02_price,
                  market[0].back02_size,
                  market[0].runner1,
                  1,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back02_price }}</b
              ><br /><small>{{
                market[0].back02_size | numberFormatter
              }}</small>
            </button>
            <!-- back3 runner1 end -->
            <!-- back2 runner1 start -->
            <button
              #btn
              mat-button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].back01_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back01_price,
                  market[0].back01_size,
                  market[0].runner1,
                  1,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back01_price }}</b
              ><br /><small>{{
                market[0].back01_size | numberFormatter
              }}</small>
            </button>
            <!-- back2 runner1 end -->
            <!-- back1 runner1 start -->
            <button
              #btn
              mat-button
              *ngIf="
                market[0].is_suspended0 == 0 && market[0].status == 'OPEN';
                else MarketSuspendedBlock
              "
              [disabled]="market[0].back0_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back0_price,
                  market[0].back0_size,
                  market[0].runner1,
                  1,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back0_price }}</b
              ><br /><small>{{ market[0].back0_size | numberFormatter }}</small>
            </button>
            <!-- back1 runner1 end -->
            <ng-template #MarketSuspendedBlock>
              <div
                title="SUSPENDED"
                class="suspendedtext d-flex justify-content-between"
              >
                <!-- <button class="btn mbtn bg-blue p-0 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button> -->
                <button class="btn mbtn bg-blue p-0 font-weight-bold">
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-2 font-weight-bold">
                  0 <br /><small>0</small>
                </button>
              </div>
            </ng-template>
            <br />
            <!-- lay1 runner1 start -->
            <button
              *ngIf="market[0].is_suspended0 == 0 && market[0].status == 'OPEN'"
              [disabled]="market[0].lay0_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay0_price,
                  market[0].lay0_size,
                  market[0].runner1,
                  1,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay0_price }}</b> <br /><small>{{
                market[0].lay0_size | numberFormatter
              }}</small>
            </button>
            <!-- lay1 runner1 end -->
            <!-- lay2 runner1 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].lay01_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay01_price,
                  market[0].lay01_size,
                  market[0].runner1,
                  1,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay01_price }}</b> <br /><small>{{
                market[0].lay01_size | numberFormatter
              }}</small>
            </button>
            <!-- lay2 runner1 end -->
            <!-- lay3 runner1 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].lay02_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay02_price,
                  market[0].lay02_size,
                  market[0].runner1,
                  1,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay02_price }}</b> <br /><small>{{
                market[0].lay02_size | numberFormatter
              }}</small>
            </button>
            <!-- lay3 runner1 end -->
            <br />
          </div>
          <div class="d-flex justify-content-between p-1 border-secondary">
            <div class="title" style="font-weight:700 !important;">
              <span class=" span font-12" style="font-weight: 700 !important;">{{ market[0].runner2 }}</span
              ><br />
              <span
                *ngIf="market[0].exp_amount2 != 0"
                class="font-weight-bold"
                [class.text-danger]="market[0].exp_amount2 < 0"
                [class.text-success]="market[0].exp_amount2 >= 0"
                >{{ market[0].exp_amount2 }}</span
              >
            </div>
            <!-- back3 runner2 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].back12_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back12_price,
                  market[0].back12_size,
                  market[0].runner2,
                  2,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back12_price }}</b> <br /><small>{{
                market[0].back12_size | numberFormatter
              }}</small>
            </button>
            <!-- back3 runner2 end -->
            <!-- back2 runner2 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].back11_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back11_price,
                  market[0].back11_size,
                  market[0].runner2,
                  2,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back11_price }}</b> <br /><small>{{
                market[0].back11_size | numberFormatter
              }}</small>
            </button>
            <!-- back2 runner2 end -->
            <!-- back1 runner2 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 && market[0].status == 'OPEN';
                else MarketSuspendedBlock
              "
              [disabled]="market[0].back1_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back1_price,
                  market[0].back1_size,
                  market[0].runner2,
                  2,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back1_price }}</b> <br /><small>{{
                market[0].back1_size | numberFormatter
              }}</small>
            </button>
            <!-- back1 runner2 end -->
            <br />
            <!-- lay1 runner2 start -->
            <button
              *ngIf="market[0].is_suspended0 == 0 && market[0].status == 'OPEN'"
              [disabled]="market[0].lay1_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay1_price,
                  market[0].lay1_size,
                  market[0].runner2,
                  2,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay1_price }}</b> <br /><small>{{
                market[0].lay1_size | numberFormatter
              }}</small>
            </button>
            <!-- lay1 runner2 end -->
            <!-- lay2 runner2 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].lay11_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay11_price,
                  market[0].lay11_size,
                  market[0].runner2,
                  2,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay11_price }}</b> <br /><small>{{
                market[0].lay11_size | numberFormatter
              }}</small>
            </button>
            <!-- lay2 runner2 end -->
            <!-- lay3 runner2 start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].lay12_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay12_price,
                  market[0].lay12_size,
                  market[0].runner2,
                  2,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay12_price }}</b> <br /><small>{{
                market[0].lay12_size | numberFormatter
              }}</small>
            </button>
            <!-- lay3 runner2 end -->
            <br />
          </div>
          <div
            *ngIf="market[0].back2_price != null"
            class="d-flex justify-content-between p-1 border-secondary"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class=" span font-12" style="font-weight: 700 !important;">Draw</span><br />
              <span
                *ngIf="market[0].exp_amount3 != 0"
                class="font-weight-bold"
                [class.text-danger]="market[0].exp_amount3 < 0"
                [class.text-success]="market[0].exp_amount3 >= 0"
                >{{ market[0].exp_amount3 }}</span
              >
            </div>
            <!-- back3 draw start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].back22_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back22_price,
                  market[0].back22_size,
                  'Draw',
                  3,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back22_price }}</b> <br /><small>{{
                market[0].back22_size | numberFormatter
              }}</small>
            </button>
            <!-- back3 draw end -->
            <!-- back2 draw start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].back21_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back21_price,
                  market[0].back21_size,
                  'Draw',
                  3,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back21_price }}</b> <br /><small>{{
                market[0].back21_size | numberFormatter
              }}</small>
            </button>
            <!-- back2 draw end -->
            <!-- back1 draw start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 && market[0].status == 'OPEN';
                else MarketSuspendedBlock
              "
              [disabled]="market[0].back2_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back2_price,
                  market[0].back2_size,
                  'Draw',
                  3,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back2_price }}</b> <br /><small>{{
                market[0].back2_size | numberFormatter
              }}</small>
            </button>
            <!-- back1 draw end -->
            <br />
            <!-- lay1 draw start -->
            <button
              *ngIf="market[0].is_suspended0 == 0 && market[0].status == 'OPEN'"
              [disabled]="market[0].lay2_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay2_price,
                  market[0].lay2_size,
                  'Draw',
                  3,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay2_price }}</b> <br /><small>{{
                market[0].lay2_size | numberFormatter
              }}</small>
            </button>
            <!-- lay1 draw end -->
            <!-- lay2 draw start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].lay21_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay21_price,
                  market[0].lay21_size,
                  'Draw',
                  3,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay21_price }}</b> <br /><small>{{
                market[0].lay21_size | numberFormatter
              }}</small>
            </button>
            <!-- lay2 draw end -->
            <!-- lay3 draw start -->
            <button
              *ngIf="
                market[0].is_suspended0 == 0 &&
                market[0].status == 'OPEN' &&
                3 > 6
              "
              [disabled]="market[0].lay22_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay22_price,
                  market[0].lay22_size,
                  'Draw',
                  3,
                  100,
                  200000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay22_price }}</b> <br /><small>{{
                market[0].lay22_size | numberFormatter
              }}</small>
            </button>
            <!-- lay3 draw end -->
            <br />
          </div>
        </div>
      </div>

      <!--      Bookmaker odds starts-->
      <div class="card mt-1 rounded" *ngIf="book_maker_odd.length > 0">
        <div style="" class="text-white">
          <span class=" span newhead">
            <span style="margin-left: -10px">
              <img
                src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                class="mr-1"
              />
              <span style="position: absolute; margin-left: 7px"
                >Bookmaker</span
              >
            </span>
            <span
              class="text-light font-weight-bold float-right"
              style="font-size: 12px"
              >Min: {{ book_maker_odd[0].min }} | Max:
              {{ book_maker_odd[0].max }}</span
            >
          </span>
        </div>
        <div class="card-body p-0">
          <div>
            <table class="w-100">
              <!-- <tr>
                <td width="58%">&nbsp;</td>
                <td width="25%"><span style="font-weight: 700">BACK</span></td>
                <td width="17%"><span style="font-weight: 700">LAY</span></td>
              </tr> -->
            </table>
          </div>
          <div class="d-flex justify-content-between p-2 border-secondary">
            <div class="title" style="font-weight:700 !important;">
              <span class="span">{{ book_maker_odd[0].runner1 }}</span
              ><br />
              <!--              {{0}}-->
              <span
                class="font-weight-bold"
                *ngIf="book_maker_odd[0].exp_amount1 != 0"
                [class.text-danger]="book_maker_odd[0].exp_amount1 < 0"
                [class.text-success]="book_maker_odd[0].exp_amount1 >= 0"
                >{{
                  book_maker_odd[0].is_declared == "1"
                    ? 0
                    : book_maker_odd[0].exp_amount1
                }}</span
              >
            </div>
            <button
              #btn
              mat-button
              *ngIf="
                book_maker_odd[0].is_suspended0 == 0 &&
                  book_maker_odd[0].status == 'ACTIVE';
                else MarketSuspendedBlock
              "
              [disabled]="book_maker_odd[0].back0_price == 0"
              (click)="
                openDialog(
                  'bookmaker',
                  'Back',
                  book_maker_odd[0].back0_price,
                  book_maker_odd[0].back0_size,
                  book_maker_odd[0].runner1,
                  1,
                  book_maker_odd[0].min,
                  book_maker_odd[0].max
                )
              "
              class="btn mbtn bg-blue p-0 font-weight-bold"
            >
              <b>{{ book_maker_odd[0].back0_price }}</b
              ><br /><small>{{
                book_maker_odd[0].back0_size | numberFormatter
              }}</small>
            </button>
            <ng-template #MarketSuspendedBlock>
              <div
                title="SUSPENDED"
                class="suspendedtext d-flex justify-content-between"
              >
                <button class="btn mbtn bg-blue p-0 font-weight-bold">
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold">
                  0 <br /><small>0</small>
                </button>
              </div>
            </ng-template>
            <br />
            <button
              *ngIf="
                book_maker_odd[0].is_suspended0 == 0 &&
                book_maker_odd[0].status == 'ACTIVE'
              "
              [disabled]="book_maker_odd[0].lay0_price == 0"
              (click)="
                openDialog(
                  'bookmaker',
                  'Lay',
                  book_maker_odd[0].lay0_price,
                  book_maker_odd[0].lay0_size,
                  book_maker_odd[0].runner1,
                  1,
                  book_maker_odd[0].min,
                  book_maker_odd[0].max
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold"
            >
              <b>{{ book_maker_odd[0].lay0_price }}</b> <br /><small>{{
                book_maker_odd[0].lay0_size | numberFormatter
              }}</small>
            </button>
            <br />
          </div>
          <div
            class="d-flex justify-content-between p-2 border-secondary border-top"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class="span">{{ book_maker_odd[0].runner2 }}</span
              ><br />
              <span
                class="font-weight-bold"
                *ngIf="book_maker_odd[0].exp_amount2 != 0"
                [class.text-danger]="book_maker_odd[0].exp_amount2 < 0"
                [class.text-success]="book_maker_odd[0].exp_amount2 >= 0"
                >{{
                  book_maker_odd[0].is_declared == "1"
                    ? 0
                    : book_maker_odd[0].exp_amount2
                }}</span
              >
            </div>
            <button
              *ngIf="
                book_maker_odd[0].is_suspended1 == 0 &&
                  book_maker_odd[0].status1 == 'ACTIVE';
                else MarketSuspendedBlock
              "
              [disabled]="book_maker_odd[0].back1_price == 0"
              (click)="
                openDialog(
                  'bookmaker',
                  'Back',
                  book_maker_odd[0].back1_price,
                  book_maker_odd[0].back1_size,
                  book_maker_odd[0].runner2,
                  2,
                  book_maker_odd[0].min,
                  book_maker_odd[0].max
                )
              "
              class="btn mbtn bg-blue p-0 font-weight-bold"
            >
              <b>{{ book_maker_odd[0].back1_price }}</b> <br /><small>{{
                book_maker_odd[0].back1_size | numberFormatter
              }}</small>
            </button>
            <br />
            <button
              *ngIf="
                book_maker_odd[0].is_suspended1 == 0 &&
                book_maker_odd[0].status1 == 'ACTIVE'
              "
              [disabled]="book_maker_odd[0].lay1_price == 0"
              (click)="
                openDialog(
                  'bookmaker',
                  'Lay',
                  book_maker_odd[0].lay1_price,
                  book_maker_odd[0].lay1_size,
                  book_maker_odd[0].runner2,
                  2,
                  book_maker_odd[0].min,
                  book_maker_odd[0].max
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold"
            >
              <b>{{ book_maker_odd[0].lay1_price }}</b> <br /><small>{{
                book_maker_odd[0].lay1_size | numberFormatter
              }}</small>
            </button>
            <br />
          </div>
          <div
            *ngIf="book_maker_odd[0].back2_price != null"
            class="d-flex justify-content-between p-2 border-secondary border-top"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class="span">Draw</span><br />
              <span
                *ngIf="book_maker_odd[0].exp_amount3 != 0"
                class="font-weight-bold"
                [class.text-danger]="book_maker_odd[0].exp_amount3 < 0"
                [class.text-success]="book_maker_odd[0].exp_amount3 >= 0"
                >{{
                  book_maker_odd[0].is_declared == "1"
                    ? 0
                    : book_maker_odd[0].exp_amount3
                }}</span
              >
            </div>
            <button
              *ngIf="
                book_maker_odd[0].is_suspended2 == 0 &&
                  book_maker_odd[0].status2 == 'ACTIVE';
                else MarketSuspendedBlock
              "
              [disabled]="book_maker_odd[0].back2_price == 0"
              (click)="
                openDialog(
                  'bookmaker',
                  'Back',
                  book_maker_odd[0].back2_price,
                  book_maker_odd[0].back2_size,
                  'Draw',
                  3,
                  book_maker_odd[0].min,
                  book_maker_odd[0].max
                )
              "
              class="btn mbtn bg-blue p-0 font-weight-bold"
            >
              <b>{{ book_maker_odd[0].back2_price }}</b> <br /><small>{{
                book_maker_odd[0].back2_size | numberFormatter
              }}</small>
            </button>
            <br />
            <button
              *ngIf="
                book_maker_odd[0].is_suspended2 == 0 &&
                book_maker_odd[0].status2 == 'ACTIVE'
              "
              [disabled]="book_maker_odd[0].lay2_price == 0"
              (click)="
                openDialog(
                  'bookmaker',
                  'Lay',
                  book_maker_odd[0].lay2_price,
                  book_maker_odd[0].lay2_size,
                  'Draw',
                  3,
                  book_maker_odd[0].min,
                  book_maker_odd[0].max
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold"
            >
              <b>{{ book_maker_odd[0].lay2_price }}</b> <br /><small>{{
                book_maker_odd[0].lay2_size | numberFormatter
              }}</small>
            </button>
            <br />
          </div>
        </div>
      </div>
      <!--      Bookmaker odds ends-->
      <!--      fancy started-->
      <div
        class="card mt-1 rounded"
        *ngIf="fancies.length > 0 && fancies[0].is_declared != 1"
      >
        <div style="" class="text-white">
          <span class=" span newhead">
            <span style="margin-left: -10px">
              <img
                src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                class="mr-1"
              />
              <span style="position: absolute; margin-left: 7px">Toss</span>
            </span>
            <span
              class="text-light float-right"
              style="font-size: 12px; font-weight: 600px"
              >Max: 2L</span
            >
          </span>
        </div>
        <style>
            .btn{
                
            }
        </style>
        <div class="card-body p-0">
          <div *ngFor="let fancy of fancies">
            <div
              *ngIf="fancy.is_active"
              class="p-2 border-secondary border-bottom"
            >
              <div class="title" *ngIf="3 > 6">
                <span
                  [class.text-danger]="fancy.exp_amount != 0"
                  [class.text-success]="fancy.exp_amount == 0"
                  class="d-none"
                  >{{ fancy.exp_amount }}
                </span>
                &nbsp;
                <span class=" span session_event">{{ fancy.runner_name }}</span>
              </div>
              <div
                class="title"
                *ngIf="
                  fancy.game_status != 'SUSPENDED' && !fancy.is_suspended;
                  else suspendedBlock
                "
              >
                <!--                {{fancy.game_status != 'SUSPENDED' && !fancy.is_suspended}}-->
                <div class="d-flex justify-content-between">
                  <div class="title pl-0 pr-1">
                    <span class=" span length-fix">{{ fancy.runner_name }}</span
                    ><br />
                    <span
                      class="font-weight-bold"
                      *ngIf="fancy.exp_amount != 0"
                      [class.text-danger]="fancy.exp_amount < 0"
                      [class.text-success]="fancy.exp_amount >= 0"
                      >{{ fancy.exp_amount }}</span
                    >
                  </div>
                  <button
                    [disabled]="fancy.back_price == 0"
                    (click)="
                      openDialog(
                        'fancy',
                        'Back',
                        fancy.back_price,
                        fancy.back_size,
                        fancy.runner_name,
                        1,
                        100,
                        100000
                      )
                    "
                    class="btn mbtn bg-blue p-0 font-weight-bold"
                  >
                    <b>{{ fancy.back_price }}</b> <br /><small>{{
                      fancy.back_size
                    }}</small>
                  </button>
                  <br />
                  <button
                    [disabled]="fancy.lay_price == 0"
                    (click)="
                      openDialog(
                        'fancy',
                        'Lay',
                        fancy.lay_price,
                        fancy.lay_size,
                        fancy.runner_name,
                        0,
                        100,
                        100000
                      )
                    "
                    class="btn mbtn bg-pink ml-1 p-0 font-weight-bold"
                  >
                    <b>{{ fancy.lay_price }}</b> <br /><small>{{
                      fancy.lay_size
                    }}</small>
                  </button>
                </div>
              </div>

              <ng-template #suspendedBlock>
                <div class="d-flex justify-content-between">
                  <div class="title pl-1 pr-1">
                    <span class=" span length-fix">{{ fancy.runner_name }}</span
                    ><br />
                    <span class=" span font-weight-bold text-success">0</span>
                  </div>
                  <div
                    title="{{ fancy.game_status }}"
                    class="suspendedtext d-flex justify-content-between"
                  >
                    <button class="btn mbtn bg-blue p-0 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                    <button class="btn mbtn bg-blue p-0 ml-2 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <!--      fancy ended-->
      <!--      sessions started-->
      <div class="card mt-1 rounded" *ngIf="sessions.length > 0">
        <div style="" class="text-white">
          <div class="title text-light">
            <span class=" span newhead">
              <span style="margin-left: -10px">
                <img
                  src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                  class="mr-1"
                />
                <span style="position: absolute; margin-left: 7px"
                  >Session</span
                >
              </span>
              <!-- <span
                class="text-light float-right"
                style="font-size: 12px; font-weight: 600px"
                >Max: 1L</span
              > -->
            </span>
          </div>
        </div>
        <div class="card-body p-0">
          <div *ngFor="let session of sessions">
            <div
              *ngIf="session.is_active"
              class="p-2 border-secondary border-bottom"
            >
              <div class="title" style="font-weight:700 !important;">
                  <div style="display:flex;">
                <span class=" span session_event" style="    width: 100%;
">{{ session.runner_name }}</span>
                <div>
                <span 
                    style="    position: relative;
    text-align: center;
    width: 15.7%;"
                  class="float-right"
                  (click)="openLadder(session.runner_name, session.event_id)"
                >
                  <span
                 
                    *ngIf="session.exp_amount != 0"
                    [class.text-danger]="session.exp_amount != 0"
                    [class.text-success]="session.exp_amount == 0"
                    >{{ session.exp_amount }}</span
                  >
                  <!-- <img style="height: 30px;" src="/assets/icons/ladder.png" alt=""> -->
                </span>
              </div>
              <div
                class="title"
                *ngIf="session.game_status === ''; else suspendedBlock"
              >
                <!--                {{session.game_status != 'SUSPENDED' && !session.is_suspended}}-->
                <div class="d-flex justify-content-between">
                  <button
                    [disabled]="session.lay_size == 0"
                    (click)="
                      openDialog(
                        'session',
                        'Lay',
                        session.lay_price,
                        session.lay_size,
                        session.runner_name,
                        0,
                        session.min,
                        session.max
                      )
                    "
                    class="btn mbtn bg-pink p-0 font-weight-bold"
                  >
                    <b>{{ session.lay_price }}</b> <br /><small>{{
                      session.lay_size
                    }}</small>
                  </button>
                  <br />
                  <button
                    [disabled]="session.back_size == 0"
                    (click)="
                      openDialog(
                        'session',
                        'Back',
                        session.back_price,
                        session.back_size,
                        session.runner_name,
                        0,
                        session.min,
                        session.max
                      )
                    "
                    class="btn mbtn bg-blue p-0 ml-2 font-weight-bold"
                  >
                    <b>{{ session.back_price }}</b> <br /><small>{{
                      session.back_size
                    }}</small>
                  </button>
                  <div class="mbtn text-right font-weight-bold mblockonmobile">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:50k</span>
                  </div>
                </div>
              </div>
<style>
   
</style>
              <ng-template #suspendedBlock style="width: 100% !important;">
                <div class="d-flex "style="width: 100% !important; justify-content: end !important;
">
                  <div
                    data-title="{{ session.game_status }}"
                    class="suspendedtext d-flex " style="    justify-content: end;
"
                  >
                    <button class="btn mbtn bg-pink p-0 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                    <button class="btn mbtn bg-blue p-0 ml-2 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                  </div>
                  <div class="mbtn text-right">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:1L</span>
                  </div>
                </div>
              </ng-template>
              </div></div>
            </div>
          </div>
        </div>
      </div>
      <!--      sessions ended-->
      <!--      ballbyball started-->
      <div class="card mt-1 rounded" *ngIf="ballbyball.length > 0">
        <div style="" class="text-white">
          <div class="title text-light">
            <span class=" span newhead">
              <span style="margin-left: -10px">
                <img
                  src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                  class="mr-1"
                />
                <span style="position: absolute; margin-left: 7px"
                  >Ball by Ball</span
                >
              </span>
              <!-- <span
                class="text-light float-right"
                style="font-size: 12px; font-weight: 600px"
                >Max: 1L</span
              > -->
            </span>
          </div>
        </div>
        <div class="card-body p-0">
          <div *ngFor="let byb of ballbyball">
            <div
              *ngIf="byb.is_active"
              class="p-2 border-secondary border-bottom"
            >
              <div class="title" style="font-weight:700 !important;">
                <span class=" span session_event">{{ byb.runner_name }}</span>
                <span
                  class="float-right"
                  (click)="openLadder(byb.runner_name, byb.event_id)"
                >
                  <span
                    *ngIf="byb.exp_amount != 0"
                    [class.text-danger]="byb.exp_amount != 0"
                    [class.text-success]="byb.exp_amount == 0"
                    >{{ byb.exp_amount }}</span
                  >
                  <!-- <img style="height: 30px;" src="/assets/icons/ladder.png" alt=""> -->
                </span>
              </div>
              <div
                class="title"
                *ngIf="byb.game_status === ''; else suspendedBlock"
              >
                <!--                {{byb.game_status != 'SUSPENDED' && !byb.is_suspended}}-->
                <div class="d-flex justify-content-between">
                  <button
                    [disabled]="byb.lay_size == 0"
                    (click)="
                      openDialog(
                        'session',
                        'Lay',
                        byb.lay_price,
                        byb.lay_size,
                        byb.runner_name,
                        0,
                        byb.min,
                        byb.max
                      )
                    "
                    class="btn mbtn bg-pink p-0 font-weight-bold"
                  >
                    <b>{{ byb.lay_price }}</b> <br /><small>{{
                      byb.lay_size
                    }}</small>
                  </button>
                  <br />
                  <button
                    [disabled]="byb.back_size == 0"
                    (click)="
                      openDialog(
                        'session',
                        'Back',
                        byb.back_price,
                        byb.back_size,
                        byb.runner_name,
                        0,
                        byb.min,
                        byb.max
                      )
                    "
                    class="btn mbtn bg-blue p-0 ml-2 font-weight-bold"
                  >
                    <b>{{ byb.back_price }}</b> <br /><small>{{
                      byb.back_size
                    }}</small>
                  </button>
                  <div class="mbtn text-right font-weight-bold mblockonmobile">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:50k</span>
                  </div>
                </div>
              </div>

              <ng-template #suspendedBlock>
                <div class="d-flex justify-content-between">
                  <div
                    data-title="{{ byb.game_status }}"
                    class="suspendedtext d-flex justify-content-between"
                  >
                    <button class="btn mbtn bg-pink p-0 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                    <button class="btn mbtn bg-blue p-0 ml-2 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                  </div>
                  <div class="mbtn text-right">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:1L</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <!--      ballbyball ended-->
      <!--      overbyovers started-->
      <div class="card mt-1 rounded" *ngIf="overbyovers.length > 0">
        <div style="" class="text-white">
          <div class="title text-light">
            <span class=" span newhead">
              <span style="margin-left: -10px">
                <img
                  src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                  class="mr-1"
                />
                <span style="position: absolute; margin-left: 7px"
                  >Over by Over</span
                >
              </span>
              <!-- <span
                class="text-light float-right"
                style="font-size: 12px; font-weight: 600px"
                >Max: 1L</span
              > -->
            </span>
          </div>
        </div>
        <div class="card-body p-0">
          <div *ngFor="let overbyover of overbyovers">
            <div
              *ngIf="overbyover.is_active"
              class="p-2 border-secondary border-bottom"
            >
              <div class="title" style="font-weight:700 !important;">
                <span class=" span session_event">{{ overbyover.runner_name }}</span>
                <span
                  class="float-right"
                  (click)="
                    openLadder(overbyover.runner_name, overbyover.event_id)
                  "
                >
                  <span
                    *ngIf="overbyover.exp_amount != 0"
                    [class.text-danger]="overbyover.exp_amount != 0"
                    [class.text-success]="overbyover.exp_amount == 0"
                    >{{ overbyover.exp_amount }}</span
                  >
                  <!-- <img style="height: 30px;" src="/assets/icons/ladder.png" alt=""> -->
                </span>
              </div>
              <div
                class="title"
                *ngIf="overbyover.game_status === ''; else suspendedBlock"
              >
                <!--                {{overbyover.game_status != 'SUSPENDED' && !overbyover.is_suspended}}-->
                <div class="d-flex justify-content-between">
                  <button
                    [disabled]="overbyover.lay_size == 0"
                    (click)="
                      openDialog(
                        'session',
                        'Lay',
                        overbyover.lay_price,
                        overbyover.lay_size,
                        overbyover.runner_name,
                        0,
                        overbyover.min,
                        overbyover.max
                      )
                    "
                    class="btn mbtn bg-pink p-0 font-weight-bold"
                  >
                    <b>{{ overbyover.lay_price }}</b> <br /><small>{{
                      overbyover.lay_size
                    }}</small>
                  </button>
                  <br />
                  <button
                    [disabled]="overbyover.back_size == 0"
                    (click)="
                      openDialog(
                        'session',
                        'Back',
                        overbyover.back_price,
                        overbyover.back_size,
                        overbyover.runner_name,
                        0,
                        overbyover.min,
                        overbyover.max
                      )
                    "
                    class="btn mbtn bg-blue p-0 ml-2 font-weight-bold"
                  >
                    <b>{{ overbyover.back_price }}</b> <br /><small>{{
                      overbyover.back_size
                    }}</small>
                  </button>
                  <div class="mbtn text-right font-weight-bold mblockonmobile">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:50k</span>
                  </div>
                </div>
              </div>

              <ng-template #suspendedBlock>
                <div class="d-flex justify-content-between">
                  <div
                    data-title="{{ overbyover.game_status }}"
                    class="suspendedtext d-flex justify-content-between"
                  >
                    <button class="btn mbtn bg-pink p-0 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                    <button class="btn mbtn bg-blue p-0 ml-2 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                  </div>
                  <div class="mbtn text-right">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:1L</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <!--      overbyover ended-->
      <!----- meter started-->
      <div class="card mt-1 rounded" *ngIf="meters.length > 0">
        <div style="" class="text-white">
          <div class="title text-light">
            <span class=" span newhead">
              <span style="margin-left: -10px">
                <img
                  src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                  class="mr-1"
                />
                <span style="position: absolute; margin-left: 7px">Meter</span>
              </span>
              <!-- <span
                      class="text-light float-right"
                      style="font-size: 12px; font-weight: 600px"
                      >Max: 1L</span
                    > -->
            </span>
          </div>
        </div>
        <div class="card-body p-0">
          <div *ngFor="let meter of meters">
            <div
              *ngIf="meter.is_active"
              class="p-2 border-secondary border-bottom"
            >
              <div class="title" style="font-weight:700 !important;">
                <span class=" span session_event">{{ meter.runner_name }}</span>
                <span
                  class="float-right"
                  (click)="openLadder(meter.runner_name, meter.event_id)"
                >
                  <span
                    *ngIf="meter.exp_amount != 0"
                    [class.text-danger]="meter.exp_amount != 0"
                    [class.text-success]="meter.exp_amount == 0"
                    >{{ meter.exp_amount }}</span
                  >
                  <!-- <img style="height: 30px;" src="/assets/icons/ladder.png" alt=""> -->
                </span>
              </div>
              <div
                class="title"
                *ngIf="meter.game_status === ''; else suspendedBlock"
              >
                <!--                {{meter.game_status != 'SUSPENDED' && !meter.is_suspended}}-->
                <div class="d-flex justify-content-between">
                  <button
                    [disabled]="meter.lay_size == 0"
                    (click)="
                      openDialog(
                        'meter',
                        'Lay',
                        meter.lay_price,
                        meter.lay_size,
                        meter.runner_name,
                        0,
                        meter.min,
                        meter.max
                      )
                    "
                    class="btn mbtn bg-pink p-0 font-weight-bold"
                  >
                    <b>{{ meter.lay_price }}</b> <br /><small>{{
                      meter.lay_size
                    }}</small>
                  </button>
                  <br />
                  <button
                    [disabled]="meter.back_size == 0"
                    (click)="
                      openDialog(
                        'meter',
                        'Back',
                        meter.back_price,
                        meter.back_size,
                        meter.runner_name,
                        0,
                        meter.min,
                        meter.max
                      )
                    "
                    class="btn mbtn bg-blue p-0 ml-2 font-weight-bold"
                  >
                    <b>{{ meter.back_price }}</b> <br /><small>{{
                      meter.back_size
                    }}</small>
                  </button>
                  <div class="mbtn text-right font-weight-bold mblockonmobile">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:50k</span>
                  </div>
                </div>
              </div>

              <ng-template #suspendedBlock>
                <div class="d-flex justify-content-between">
                  <div
                    data-title="{{ meter.game_status }}"
                    class="suspendedtext d-flex justify-content-between"
                  >
                    <button class="btn mbtn bg-pink p-0 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                    <button class="btn mbtn bg-blue p-0 ml-2 font-weight-bold">
                      0 <br /><small>0</small>
                    </button>
                  </div>
                  <div class="mbtn text-right">
                    <span class="span">Min:100</span><br />
                    <span class="span">Max:1L</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <!----- meter ended-->
    </mat-tab>

    <mat-tab *ngIf="3 > 6" label="BETs">
      <!--      match bets-->
      <div class="card mt-3 rounded" *ngIf="match_bets.length > 0">
        <div style="" class="text-light">
          <div class="title text-light">
            <span class=" span newhead">Match Bets</span><br />
          </div>
        </div>
        <div class="card-body p-0">
          <div
            (click)="selectTab(0)"
            *ngFor="let matchbet of match_bets"
            class="d-flex justify-content-between p-2 border-secondary border-bottom"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class="span">{{ matchbet.runner_name + "  " }}</span
              ><span
                style="font-size: 13px"
                class="badge"
                [class.badge-danger]="matchbet.is_won == 0"
                [class.badge-success]="matchbet.is_won == 1"
                [class.badge-secondary]="matchbet.is_won == 2"
                *ngIf="matchbet.status == 0"
                >{{
                  matchbet.is_won == 1
                    ? "Won"
                    : matchbet.is_won == 2
                    ? "Draw"
                    : "Lose"
                }}</span
              ><br />
              <span
                class="badge"
                style="font-size: 12px"
                [class.badge-info]="matchbet.type == 'Back'"
                [class.badge-danger]="matchbet.type == 'Lay'"
                >{{ matchbet.type }}</span
              ><span class=" span badge badge-warning ml-2">{{
                matchbet.status == 1 ? "OPEN" : "CLOSED"
              }}</span
              ><br />
              <span class="span">{{
                matchbet.created_at | date : "dd/MMM/YYYY, h:mm:ss a" : "IST"
              }}</span>
            </div>
            <div class="title" class="float-right w-50 text-right">
              <span class=" span text-white">Odds: Match Odds</span><br />
              <span class=" span text-white">Stack:{{ matchbet.bet_amount }}</span>
              <br />
              <span class=" span text-white">P&L: {{ matchbet.price }}</span>
            </div>
          </div>
        </div>
      </div>

      <!--      bookmaker bets start-->
      <div class="card mt-1 rounded" *ngIf="bookmaker_bets.length > 0">
        <div style="" class="text-light">
          <div class="title text-light">
            <span class=" span newhead">Bookmaker Bets</span><br />
          </div>
        </div>
        <div class="card-body p-0">
          <div
            (click)="selectTab(0)"
            *ngFor="let bookmakerbet of bookmaker_bets"
            class="d-flex justify-content-between p-2 border-secondary border-bottom"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class="span">{{ bookmakerbet.runner_name + "  " }}</span
              ><span
                style="font-size: 13px"
                class="badge"
                [class.badge-danger]="bookmakerbet.is_won == 0"
                [class.badge-success]="bookmakerbet.is_won == 1"
                [class.badge-secondary]="bookmakerbet.is_won == 2"
                *ngIf="bookmakerbet.status == 0"
                >{{
                  bookmakerbet.is_won == 1
                    ? "Won"
                    : bookmakerbet.is_won == 2
                    ? "Draw"
                    : "Lose"
                }}</span
              ><br />
              <span
                class="badge"
                style="font-size: 12px"
                [class.badge-info]="bookmakerbet.type == 'Back'"
                [class.badge-danger]="bookmakerbet.type == 'Lay'"
                >{{ bookmakerbet.type }}</span
              ><span class=" span badge badge-warning ml-2">{{
                bookmakerbet.status == 1 ? "OPEN" : "CLOSED"
              }}</span
              ><br />
              <span class="span">{{
                bookmakerbet.created_at
                  | date : "dd/MMM/YYYY, h:mm:ss a" : "IST"
              }}</span>
            </div>
            <div class="title" class="float-right w-50 text-right">
              <span class=" span text-white">Odds: Match Odds</span><br />
              <span class=" span text-white"
                >Stack:{{ bookmakerbet.bet_amount }}</span
              >
              <br />
              <span class=" span text-white">P&L: {{ bookmakerbet.price }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--      bookmaker bets ends-->
      <!--      fancy bet starts-->
      <div class="card mt-3 rounded" *ngIf="fancy_bets.length > 0">
        <div style="" class="text-light">
          <div class="title text-light">
            <span class=" span newhead">Fancy Bets</span><br />
          </div>
        </div>
        <div class="card-body p-0">
          <div
            (click)="selectTab(0)"
            *ngFor="let fancybet of fancy_bets"
            class="d-flex justify-content-between p-2 border-secondary border-bottom"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class="span">{{
                fancybet.runner_name + "  (" + fancybet.price + ")"
              }}</span
              ><span
                style="font-size: 13px"
                class="badge"
                [class.badge-danger]="fancybet.is_won == 0"
                [class.badge-success]="fancybet.is_won == 1"
                *ngIf="fancybet.status == 0"
                >{{ fancybet.is_won == 1 ? "Won" : "Lose" }}</span
              ><br />
              <span
                class="badge"
                style="font-size: 12px"
                [class.badge-info]="fancybet.type == 'Back'"
                [class.badge-danger]="fancybet.type == 'Lay'"
                >{{ fancybet.type }}</span
              ><span class=" span badge badge-warning ml-2">{{
                fancybet.status == 1 ? "OPEN" : "CLOSED"
              }}</span
              ><br />
              <span class="span">{{ fancybet.created_at | date : "short" }}</span>
            </div>
            <div
              class="title font-weight-normal"
              style="text-align: right !important"
            >
              <span class=" span text-white">Odds: Session Odds</span><br />
              <span class=" span text-white">Stack:{{ fancybet.bet_amount }}</span>
              <br />
              <span class=" span text-white">P&L: {{ fancybet.price }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--      fancy bet ends-->
      <!--      session bets-->
      <div class="card mt-3 rounded" *ngIf="session_bets.length > 0">
        <div style="" class="text-light">
          <div class="title text-light">
            <span class=" span newhead">Session Bets</span><br />
          </div>
        </div>
        <div class="card-body p-0">
          <div
            (click)="selectTab(0)"
            *ngFor="let sessionbet of session_bets"
            class="d-flex justify-content-between p-2 border-secondary border-bottom"
          >
            <div class="title" style="font-weight:700 !important;">
              <span class="span">{{
                sessionbet.runner_name + "  (" + sessionbet.price + ")"
              }}</span
              ><span
                style="font-size: 13px"
                class="badge"
                [class.badge-danger]="sessionbet.is_won == 0"
                [class.badge-success]="sessionbet.is_won == 1"
                *ngIf="sessionbet.status == 0"
                >{{ sessionbet.is_won == 1 ? "Won" : "Lose" }}</span
              ><br />
              <span
                class="badge"
                style="font-size: 12px"
                [class.badge-info]="sessionbet.type == 'Back'"
                [class.badge-danger]="sessionbet.type == 'Lay'"
                >{{ sessionbet.type }}</span
              ><span class=" span badge badge-warning ml-2">{{
                sessionbet.status == 1 ? "OPEN" : "CLOSED"
              }}</span
              ><br />
              <span class="span">{{ sessionbet.created_at | date : "short" }}</span>
            </div>
            <div
              class="title font-weight-normal"
              style="text-align: right !important"
            >
              <span class=" span text-white">Odds: Session Odds</span><br />
              <span class=" span text-white">Stack:{{ sessionbet.bet_amount }}</span>
              <br />
              <span class=" span text-white">P&L: {{ sessionbet.size }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--      session bets ends-->
    </mat-tab>
  </mat-tab-group>
  <!-- <button
    *ngIf="total_bets > 0"
    class="btn fixed-button2 p-0 showonlymobile"
    (click)="openbetlist()"
  >
    <span class=" span total-bet">{{ total_bets }}</span>
  </button> -->
</div>
<!--betlist-->
<div class="betscollom d-none d-md-block" style="width: 30%;">
   <div class="col-right col-right-login" >
    <div class="sub_path over-wrap">
        <div class="center-box">
            <div class="container-fluid titbg" style="    background-color: #072c50;
    background-image: linear-gradient(#072c50, #072c50);
    color: #fff;
        font-family: Roboto Condensed, sans-serif;
    font-size: 12px;
    height: 23px;
    margin: 0;
    padding: 0 4px;
    text-transform: uppercase;">
                <div class="w-100 float-left"><span class=" span betslip-btn active">Matched Bet</span></div>
            </div>
            <div class="mybet-alldata bg-white table-responsive">
                <table class="table table-bordered nowrap table-sm font-12 mb-4">
                    <thead>
                        <tr class="bg-dark text-white" style="    font-family: Roboto Condensed, sans-serif;
    font-size: 12px;
    height: 23px;
    margin: 0;
    padding: 0 4px;
    text-transform: uppercase;
    background-color: #f8bd23 !important;
    color: #000 !important;">
                           
                            <th style="background-color: #f8bd23 !important;
    color: #000 !important;">Matched Bet</th>
                            <th style="background-color: #f8bd23 !important;
    color: #000 !important;">Odds</th>
                            <th style="background-color: #f8bd23 !important;
    color: #000 !important;">Stake</th>
                        </tr>
                    </thead>
                    <tbody>
                     <tr *ngFor="let bet of all_bets" [ngStyle]="{'background-color': bet.type === 'back' ? '#72bbef' : bet.type === 'lay' ? '#faa9ba' : '' }">
      <td class="text-center">
        {{ bet.runner_name }}
      </td>
      <td class="text-center">
        {{ bet.price }}
      </td>
      <td class="text-center">
        {{ bet.bet_amount }}
      </td>
    </tr>
    <tr *ngIf="!match_bets || match_bets.length === 0">
      <td class="text-center text-danger" colspan="3">
        No matched bets available.
      </td>
    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</div>
</div>
